// extracted by mini-css-extract-plugin
export default {"documentation_home":"DocumentationHome_documentation_home__8iRdV"};